import * as React from 'react';
import { Router } from 'react-router-dom';
import { History } from 'history';

type CustomRouterProps = {
    children: React.ReactNode;
    history: History;
};

export default function CustomRouter(props: CustomRouterProps) {
    const [state, setState] = React.useState({
        action: props.history.action,
        location: props.history.location
    });

    React.useLayoutEffect(() => props.history.listen(setState), [props.history]);

    React.useEffect(() => {
        const hash = props.history.location.hash;
        if (hash && document.getElementById(hash.substring(1))) {
            // check if there is a hash and if there is an element with the id of the hash, if so scroll to it
            document.getElementById(hash.substring(1))?.scrollIntoView({ behavior: 'smooth' });
        }
        else {
            // otherwise scroll to the top of the page
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [props.history.location]);

    return (<Router
        location={state.location}
        navigationType={state.action}
        navigator={props.history}
        unstable_useTransitions={false}    >{props.children}</Router>)
};